import React from 'react';
import PropTypes from 'prop-types';

import IncidentTemplateListItem from './incident_template_list_item';
import IncidentTemplateListGroup from './incident_template_list_group';
import incidentTemplateImage from '@static/images/lipstick/incidents_page/Templates_empty.svg';

const styles = {
  heading: {
    marginTop: '49px',
    marginBottom: '21px',
  },
  description: {
    display: 'inline-block',
    width: '100%',
    marginBottom: '25px',
  },
};

class IncidentTemplateIndex extends React.Component {
  static propTypes = {
    page_param: PropTypes.string.isRequired,
    new_template_url: PropTypes.string.isRequired,
    use_adg3: PropTypes.bool.isRequired,
  };

  constructor(props) {
    super(props);
    this.pageParam = props.page_param;
  }

  renderAdg3HeaderInner = () => {
    return (
      <a
        href={this.props.new_template_url}
        className="cpt-button size-small style-primary"
      >
        Create template
      </a>
    );
  };

  renderHeaderInner = () => {
    return (
      <>
        <h4>Incident templates</h4>
        <a
          href={this.props.new_template_url}
          className="cpt-button size-small style-primary"
        >
          + New Incident Template
        </a>
      </>
    );
  };

  renderAdg3TemplatesEmptyState = () => {
    return (
      <>
        <div className="incidents-page-empty-state-wrapper">
          <img
            src={incidentTemplateImage}
            alt="no open template"
            className="no-incidents-img"
          />
          <div>
            <h5 className="no-incidents-heading" style={styles.heading}>
              Prepare yourself
            </h5>
            <span
              className="no-incidents-description"
              style={styles.description}
            >
              Save time and help standardize response
              <br />
              with incident templates.
            </span>
          </div>
          <a
            href={this.props.new_template_url}
            className="cpt-button size-small style-primary"
          >
            Create template
          </a>
        </div>
      </>
    );
  };

  renderTemplatesEmptyState = () => {
    return (
      <>
        {this._insertHeader()}
        <div className="table-row-group">
          <div className="table-row blank-state">
            <div>
              <strong>Proper preparation prevents poor performance!</strong>
            </div>
            <small>
              Prepare for downtime before it happens:
              <a href={this.props.new_template_url}>
                Create an incident template.
              </a>
            </small>
          </div>
        </div>
      </>
    );
  };

  _insertHeader() {
    return (
      <div className="header">
        {this.props.use_adg3
          ? this.renderAdg3HeaderInner()
          : this.renderHeaderInner()}
      </div>
    );
  }

  _buildTemplateItems() {
    const pageParam = this.pageParam;

    return (
      <div>
        {this.props.templates.map(template => {
          return (
            <div className="table-row template-item" key={template.id}>
              <IncidentTemplateListItem
                template={template}
                pageParam={pageParam}
              />
            </div>
          );
        })}
      </div>
    );
  }

  _buildTemplateGroups() {
    const pageParam = this.pageParam;

    return (
      <div className="template-group-items">
        {this.props.template_groups.map(group => (
          <IncidentTemplateListGroup
            key={group.param}
            group={group}
            pageParam={pageParam}
            use_adg3={this.props.use_adg3}
          />
        ))}
      </div>
    );
  }

  _tableRowGroupClass() {
    return `table-row-group ${
      this.props.template_groups.length ? 'has-template-groups' : ''
    }`;
  }

  render() {
    const { templates, template_groups, use_adg3 } = this.props;

    if (templates.length > 0 || template_groups.length > 0) {
      return (
        <div>
          {this._insertHeader()}
          <div className={this._tableRowGroupClass()}>
            {templates.length > 0 ? this._buildTemplateItems() : null}
            {template_groups.length > 0 ? this._buildTemplateGroups() : null}
          </div>
        </div>
      );
    }
    return (
      <div>
        {use_adg3
          ? this.renderAdg3TemplatesEmptyState()
          : this.renderTemplatesEmptyState()}
      </div>
    );
  }
}

export default IncidentTemplateIndex;
